import React from "react";
import { ArtistResults } from "./ArtistResults";

export const ArtistsHomePage: React.FC = () => {
	return <ArtistResults />;
};
